import React from 'react'
import {Info, TriangleAlert} from 'lucide-react'
import {BannerBox} from './styles/authShell.styles'
import type {AuthBannerState} from './bannerState'

export default function AuthBanner({banner}: Readonly<{banner: AuthBannerState | null}>) {
  if (!banner) return null
  const isError = banner.tone === 'error'
  return (
    <BannerBox
      $tone={banner.tone}
      role={isError ? 'alert' : 'status'}
      data-testid="auth-banner"
      data-tone={banner.tone}>
      {isError ? <TriangleAlert aria-hidden="true" /> : <Info aria-hidden="true" />}
      <span>{banner.message}</span>
    </BannerBox>
  )
}
